import { render, staticRenderFns } from "./AddressLogList.vue?vue&type=template&id=2015c114&scoped=true"
import script from "./AddressLogList.vue?vue&type=script&lang=js"
export * from "./AddressLogList.vue?vue&type=script&lang=js"
import style0 from "./AddressLogList.vue?vue&type=style&index=0&id=2015c114&prod&lang=css"
import style1 from "./AddressLogList.vue?vue&type=style&index=1&id=2015c114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015c114",
  null
  
)

export default component.exports